import Title from '@/components/ui/Title'
import Masonry, { ResponsiveMasonry } from 'react-responsive-masonry'

const TwoD = () => {
  return (
    <div className="py-4 px-8 flex flex-col gap-8">
      <Title className="w-full text-center" text="2D Work" />
      <p className="text-3xl leading-12 md:px-16">
        I have a strong 2D foundation of skills and most commonly use Clip
        Studio Pro. I am deeply interested in character/creature concepts and
        design for video games, and thoroughly enjoy creating concepts for
        projects. 2D asset creation for video games is another interest of mine,
        and I love creating cohesive and interesting visual designs for game
        narratives. I have a diverse range of 2D experiences both in creating
        finalised assets and animations, or making quick concepts and previs for
        storyboarding.
      </p>
      <ResponsiveMasonry columnsCountBreakPoints={{ 350: 1, 750: 2, 900: 3 }}>
        <Masonry>
          <img
            className="rounded-md shadow-lg"
            src="/portfolio/CharacterConcepts/turn.webp"
            alt="CharacterTurn.webp"
          />
          <img
            className="rounded-md shadow-lg"
            src="/portfolio/CharacterConcepts/dynamic-character1.webp"
            alt="Dynamic Character 1"
          />
          <img
            className="rounded-md shadow-lg"
            src="/portfolio/CharacterConcepts/dynamic-character2.webp"
            alt="Dynamic Character 2"
          />
          <img
            className="rounded-md shadow-lg"
            src="/portfolio/CharacterConcepts/character.webp"
            alt="Character"
          />
          <img
            className="rounded-md shadow-lg"
            src="/portfolio/CharacterConcepts/silhouette.webp"
            alt="Character Silhouette"
          />
          <img
            className="rounded-md shadow-lg"
            src="/portfolio/CharacterConcepts/creatures.webp"
            alt="Creature Concepts"
          />
          <img
            className="rounded-md shadow-lg"
            src="/portfolio/CharacterConcepts/character2.webp"
            alt="Character 2"
          />
          <img
            className="rounded-md shadow-lg"
            src="/portfolio/CharacterConcepts/character3.webp"
            alt="Character 3"
          />
          <img
            className="rounded-md shadow-lg"
            src="/portfolio/CharacterConcepts/jellyfish.webp"
            alt="Jellyfish"
          />
        </Masonry>
      </ResponsiveMasonry>
    </div>
  )
}

export default TwoD
